// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreateEmployeeAdvanceInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/create_employee_advance
 *
 * Validates input for creating a new employee advance.
 */
import { registerContract } from './validate'

export interface Payroll_CreateEmployeeAdvanceInput {
employee_id: string
franchise_id: number
title: string
amount: number
request_date: string
description?: string
}

registerContract('Payroll_CreateEmployeeAdvanceInput', {
  employee_id:  { type: 'string',  required: true },
  franchise_id: { type: 'number',  required: true },
  title:        { type: 'string',  required: true },
  amount:       { type: 'number',  required: true },
  request_date: { type: 'string',  required: true },
  description:  { type: 'string',  required: false },
})
